import routes from './index'

export default (() => {
  return ((routes.find(r => r.navigationRoutesEntry) || {}).children || [])
    .filter(function filterRoute (route) {
      route.children = (route.children || []).filter(filterRoute)
      return route.meta && route.meta.navi && !route.meta.navi.exclude
    })
})()
